import { useAppSelector } from 'js/store/hooks';

export function useCheckoutState() {
  return useAppSelector(state => state.checkout);
}
